var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titleSection"},[_c('b-container',{attrs:{"fluid":"lg"}},[_c('b-row',[_c('b-col',[_c('h2',[_vm._v(" "+_vm._s(_vm.content.title)+" "),_c('div',{staticClass:"line"}),_c('span',[_vm._v(_vm._s(_vm.content.subtitle))])])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }